<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable>
    <v-card ref="printCard">
      <v-toolbar color="primary"
        :title="event != null ? event?.name + ' - ' + $EVENT_STATUS_DIC[event?.status].label : ''">
        <v-btn color="black" @click="dialog = false" density="compact">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row align="center">
          <v-col cols="2">
            <strong>Data:</strong>
          </v-col>
          <v-col cols="3">
            {{ $moment.parseZone(event?.start_date).format('DD/MM/YYYY') }}
          </v-col>
          <v-col cols="2">
            <strong>Local:</strong>
          </v-col>
          <v-col cols="4">
            {{ event?.address_name }}, {{ event?.address }}
          </v-col>
          <v-spacer></v-spacer>
          <v-col align-self="start">
            <v-tooltip location="top">
              <template v-slot:activator="{ props }">
                <v-btn icon v-bind="props" variant="text" :href="event?.map_link" target="_blank">
                  <v-icon color="grey-lighten-1">mdi-map</v-icon>
                </v-btn>
              </template>
              <span>Local</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12">
            <strong>Equipe de Apoio:</strong>
          </v-col>
          <v-col cols="2">
            Coordenador:
          </v-col>
          <v-col cols="4">
            {{ event?.coordinator.name }}
          </v-col>
          <v-col cols="2">
            Assistentes:
          </v-col>
          <v-col cols="4">
            <ul>
              <li v-for="assistant in event?.staff">{{ assistant.name }}</li>
            </ul>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="6">
            <v-row>
              <v-col cols="12">
                <strong>Descrição:</strong>
              </v-col>
              <v-col cols="12">
                {{ event?.description }}
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row>
              <v-col cols="12">
                <strong>Resumo da programação:</strong>
              </v-col>
              <v-col cols="12">
                {{ event?.summary }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row align="center" class="bg-detail-lighten-3">
          <v-col cols="2">
            Saída:
          </v-col>
          <v-col cols="3">
            {{ event?.exit_point_address_name }}, {{ event?.exit_point_address }}
          </v-col>
          <v-col cols="2">
            Data:
          </v-col>
          <v-col cols="4">
            {{ $moment.parseZone(event?.exit_point_date).format('DD/MM/YY') }} às {{ event?.exit_point_time }}
          </v-col>
          <v-spacer></v-spacer>
          <v-col align-self="start">
            <v-tooltip location="top">
              <template v-slot:activator="{ props }">
                <v-btn icon v-bind="props" variant="text" :href="event?.exit_point_map_link" target="_blank">
                  <v-icon color="grey-lighten-1">mdi-map</v-icon>
                </v-btn>
              </template>
              <span>Local</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row align="center" class="bg-detail-lighten-3">
          <v-col cols="2">
            Chegada:
          </v-col>
          <v-col cols="3">
            {{ event?.arrival_point_address_name }}, {{ event?.arrival_point_address }}
          </v-col>
          <v-col cols="2">
            Data:
          </v-col>
          <v-col cols="4">
            {{ $moment.parseZone(event?.arrival_point_date).format('DD/MM/YY') }} às {{ event?.arrival_point_time }}
          </v-col>
          <v-spacer></v-spacer>
          <v-col align-self="start">
            <v-tooltip location="top">
              <template v-slot:activator="{ props }">
                <v-btn icon v-bind="props" variant="text" :href="event?.arrival_point_map_link" target="_blank">
                  <v-icon color="grey-lighten-1">mdi-map</v-icon>
                </v-btn>
              </template>
              <span>Local</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12">
            Anexos:
          </v-col>
          <v-col cols="12">
            <v-btn v-for="file in event?.files" variant="text" :href="file?.path" target="_blank">
              <v-icon color="grey-lighten-1">mdi-file-outline</v-icon>
              {{ file.original_name }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="isGroupAdmin">
          <v-col cols="12">
            <strong>Participantes:</strong>
          </v-col>
          <v-col cols="3" v-for="i of [1, 2, 3, 4]">
            <ul>
              <li v-for="invitee in eventInvitees(4, i)">
                <v-icon color="green" v-if="invitee.authorized">mdi-check</v-icon>
                <v-icon color="red" v-else>mdi-cancel</v-icon>
                {{ invitee.name }}
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="start">
          <!-- Print button -->
          <v-tooltip location="bottom">
            <template v-slot:activator="{ props }">
              <v-btn variant="text" color="secondary" v-bind="props":disabled="requestingApi"
                @click="printDialog" density="compact">
                <v-icon>mdi-printer</v-icon>
                Imprimir
              </v-btn>
            </template>
            <span>Imprimir detalhes do evento</span>
          </v-tooltip>

          <template v-if="isAdmin || canDownloadEventAuthorizations">
            <v-tooltip location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn variant="text" color="secondary" v-bind="props" :loading="requestingApi"
                  :disabled="requestingApi" @click="downloadEventAuthorizations" density="compact">
                  <v-icon>mdi-file-pdf-box</v-icon>
                  Autorizações
                </v-btn>
              </template>
              <span>Download Event Authorizations PDF</span>
            </v-tooltip>
          </template>

          <v-spacer></v-spacer>

          <!-- Close button (always visible) -->
          <v-tooltip location="bottom">
            <template v-slot:activator="{ props }">
              <v-btn variant="text" color="error" v-bind="props" :disabled="requestingApi"
                @click="dialog = false" density="compact">
                <v-icon>mdi-close</v-icon>
                Fechar
              </v-btn>
            </template>
            <span>Fechar</span>
          </v-tooltip>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import api from '@/services'

export default {
  name: "Detalhes do Evento",
  components: {},
  props: {
    user: Object,
    event: Object,
  },
  data() {
    return {
      dialog: false,
      requestingApi: false
    };
  },
  mounted() { },
  activated() { },
  methods: {
    printDialog() {
      const cardElement = this.$refs.printCard.$el;
      if (!cardElement) return;

      const cloneCard = cardElement.cloneNode(true);

      // Convert attachments to plain links before removing buttons
      this.convertAttachmentsToText(cloneCard);

      // Remove all remaining buttons
      const allButtons = cloneCard.querySelectorAll('.v-btn');
      allButtons.forEach(btn => btn.remove());

      // Replace check/cancel icons
      this.replaceIconsWithText(cloneCard);

      // Remove v-spacers
      const spacers = cloneCard.querySelectorAll('.v-spacer');
      spacers.forEach(spacer => spacer.remove());

      // Collect styles
      const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
        .map(style => style.outerHTML)
        .join('');

      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head><title>Detalhes do Evento - ${this.event?.name || 'Evento'}</title>${styles}</head>
      <body><div class="v-application">${cloneCard.outerHTML}</div></body>
    </html>
  `);
      printWindow.document.close();
      printWindow.print();
    },

    replaceIconsWithText(element) {
      const icons = element.querySelectorAll('i.v-icon');
      icons.forEach(icon => {
        const classes = Array.from(icon.classList);
        let replacement = null;

        if (classes.some(c => c.includes('mdi-check'))) {
          replacement = document.createElement('span');
          replacement.textContent = '✓';
          replacement.style.color = 'green';
          replacement.style.fontWeight = 'bold';
          replacement.className = 'print-icon-check';
        }
        else if (classes.some(c => c.includes('mdi-cancel'))) {
          replacement = document.createElement('span');
          replacement.textContent = '✗';
          replacement.style.color = 'red';
          replacement.style.fontWeight = 'bold';
          replacement.className = 'print-icon-cancel';
        }
        // Map icons are inside buttons, which are removed entirely – no need to replace them.
        else {
          // Remove any other icons (they are not needed in print)
          icon.remove();
          return;
        }

        if (replacement) {
          icon.parentNode.replaceChild(replacement, icon);
        } else {
          icon.remove();
        }
      });
    },

    convertAttachmentsToText(element) {
      const attachBtns = element.querySelectorAll('.v-card-text .v-btn');
      attachBtns.forEach(btn => {
        // Extract the file name – it might be inside a span or directly as text node
        // In your template, the button has an icon and then the file name as text.
        let fileName = '';
        // Get all child nodes and find text nodes (excluding the icon)
        const childNodes = btn.childNodes;
        for (let node of childNodes) {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
            fileName = node.textContent.trim();
            break;
          }
        }
        if (!fileName) {
          // Fallback: get the text from the button
          fileName = btn.textContent.trim();
        }
        const href = btn.getAttribute('href') || '#';
        const link = document.createElement('a');
        link.href = href;
        link.textContent = fileName;
        link.className = 'print-attachment';
        link.target = '_blank';
        btn.parentNode.replaceChild(link, btn);
      });
    },
    downloadSearch() {
      const vm = this;

      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.pdf.downloadPersonEventAuthorization({ event_id: vm.event.id })
            .then((result) => {
              const href = URL.createObjectURL(result);

              // create "a" HTML element with href to file & click
              const link = document.createElement('a');
              link.href = href;

              link.setAttribute('download', `Autorizações_${vm.$moment(new Date()).format("YYYYMMDD-HH_mm_ss")}.pdf`); //or any other extension
              document.body.appendChild(link);
              link.click();

              // clean up "a" element & remove ObjectURL
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
              resolve(true);
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
                reject(err.message);
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    downloadEventAuthorizations() {
      const vm = this;

      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.pdf.downloadEventAuthorizations({ event_id: vm.event.id })
            .then((result) => {
              const href = URL.createObjectURL(result);

              // create "a" HTML element with href to file & click
              const link = document.createElement('a');
              link.href = href;
              const timestamp = vm.$moment(new Date()).format("YYYYMMDD-HH_mm_ss");
              // Normalize and sanitize the event name
              const rawName = vm.event?.name || '';
              const normalizedName = rawName
                .toLowerCase()                         // convert everything to lowercase first
                .split(/\s+/)                          // split by one or more spaces
                .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize first letter of each word
                .join('_');                            // join with underscores
              const fileName = `Autorizações_${normalizedName}_${timestamp}.pdf`;

              link.setAttribute('download', fileName); //or any other extension
              document.body.appendChild(link);
              link.click();

              // clean up "a" element & remove ObjectURL
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
              console.log('Download iniciado:', fileName, vm.requestingApi);
              resolve(true);
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
                reject(err.message);
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    eventInvitees(chunks, chunk) {
      const vm = this;

      if (!vm.event?.invitees || vm.event?.invitees?.length <= 0) return [];
      const sz = vm.event.invitees.length;
      const qtItems = Math.ceil(sz / chunks);
      const start = (chunk - 1) * qtItems;
      const end = (chunk == chunks ? sz : chunk * qtItems);

      return vm.event.invitees.slice(start, end);
    }
  },
  computed: {
    isGroupAdmin() {
      const vm = this;

      return vm.user.access_level >= vm.$USER_ACCESS_LEVELS_DIC.GROUP_ADMIN.value;
    },
    isAdmin() {
      const vm = this;

      return vm.user.access_level >= vm.$USER_ACCESS_LEVELS_DIC.ADMIN.value;
    },
    canDownloadEventAuthorizations() {
      const vm = this;

      const isChief = vm.user.access_level >= vm.$USER_ACCESS_LEVELS_DIC.CHIEF.value;
      const isCoordinator = vm.event?.coordinator_id === vm.user?.legal_person?.id;
      const isStaff = vm.event?.staff?.some(s => s.id === vm.user?.legal_person?.id);

      return isChief || isCoordinator || isStaff;
    },
  },
  emits: ['closed'],
  watch: {
    event: {
      handler(newValue) {
        const vm = this;

        if (newValue) {
          newValue.invitees = newValue?.invitees.map(i => {
            i['authorized'] = newValue.authorizations.some(a => a.invitee_id === i.id && a.status === vm.$EVENT_AUTHORIZATION_STATUS_DIC.AUTHORIZED.value);
            i['visible'] = i.user_id === vm.user.id || i.parents.some(p => p.parent_person.user_id === vm.user.id);
            return i;
          });
          vm.dialog = true;
        }
      },
      immediate: true
    },
    dialog(newValue) {
      if (!newValue) {
        this.$emit('closed');
      }
    }
  }
};
</script>
